module.exports = __webpack_public_path__ + "static/media/menu-icon.21bef814.svg";